import React from "react"
import Layout from "../components/layout"
import Image from "../components/image"

const IndexPage = () => (
  <Layout>
    <Image />
  </Layout>
)

export default IndexPage
